import React from 'react';
import Grid from "@material-ui/core/Grid";
import {Link} from "react-router-dom";

// images
import Shape2 from '../../images/shape2.png';
import bgShape3 from '../../images/bg-shape3.png';

import './style.scss';

const AboutOne2Pay = () => {
    return(
        <Grid className="AboutOne2PayWrapper">
            <Grid
                container
                alignItems="center"
                spacing={4}
                className="container">
                <Grid item xs={12} md={6}>
                    <Grid className="textThumb">
                        <img className="Shape2" src={Shape2} alt="shape"/>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid className="textContent">
                        <strong>OneTwo For You </strong>
                        <h2><span>Let’s Get You Those</span> Pay Stubs</h2>
                        <p>We are your trusted pay stub solution. Employers are legally required to offer pay stubs if requested by an employee. If you need to make up some pay stubs, our simple service allows you to generate professional pay stubs with the option to add your company’s logo. Members can save employee information and auto-generate future pay stubs to make the whole process that much quicker. We’ll take care of the calculations, provide a summary of employer and employee remittances, and hook you up with a T4 report to top it off. We accommodate everything from simple earnings to multiple income types and taxable benefits. Let’s do this!</p>
                        <Link to="/about-us" className="cBtn">Create A Pay Stub</Link>
                    </Grid>
                </Grid>
            </Grid>
            <img src={bgShape3} alt="bgShape3" className="bgShape3"/>
        </Grid>
    )
};

export default AboutOne2Pay;